import React from 'react';
import { List } from 'components/ui';
import ListItem from 'components/space_users/index/list_item';
import ListHeader from 'components/space_users/index/list_header';
import Loader from 'components/loader';

const Index = ({ permissions, onRemove, sortBy, onSortChange, loading }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader
        visible={permissions.length > 0}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      {permissions.map((permission) => (
        <ListItem key={permission.id} permission={permission} onRemove={onRemove} />
      ))}
    </List>
  );
};

export default Index;
